import React from "react"
import styled from "styled-components"
import Tooltip from "component_library/components/react/Tooltip"
import NavigationInsideLink from "./NavigationInsideLink"

const CurrentTool = styled.div<{ isActive: boolean }>`
  background: ${({ isActive }) =>
    isActive
      ? "linear-gradient(90deg, rgba(1, 172, 219, 0.3) 0%, rgba(1, 172, 219, 0) 100%)"
      : `transparent`};
  transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);
  position: relative;

  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 100%;
    background-color: ${({ theme, isActive }) =>
      isActive ? theme.blue_500 : `transparent`};
    z-index: 1;
  }

  &:hover {
    background: linear-gradient(
      90deg,
      rgba(1, 172, 219, 0.3) 0%,
      rgba(1, 172, 219, 0) 100%
    );
  }
`
export interface NavigationLinkProps {
  active: boolean
  label: string
  Icon: React.FC
  link: {
    to: string
    component: React.ElementType
    additionalActiveRoutes?: ((path: string) => boolean)[]
  }
  currentPathname: string
  sidebarCollapsed: boolean
  labelBadge?: string
}

const NavigationLink = ({
  link,
  active,
  Icon,
  label,
  labelBadge,
  currentPathname,
  sidebarCollapsed,
}: NavigationLinkProps) => {
  const additionalActiveRoute = link.additionalActiveRoutes?.find(
    (currentPathFunction) => {
      return currentPathFunction(currentPathname)
    }
  )

  // Check if the route is active
  const isActive = currentPathname === link.to || !!additionalActiveRoute

  if (!active) return null

  return (
    <link.component
      to={link.to}
      href={link.to}
      style={{ textDecoration: "none" }}
    >
      <CurrentTool isActive={isActive}>
        {sidebarCollapsed ? (
          <Tooltip direction="right" tip={label}>
            <NavigationInsideLink
              isActive={isActive}
              Icon={Icon}
              text=""
              smallBadge
              labelBadge={labelBadge}
            />
          </Tooltip>
        ) : (
          <NavigationInsideLink
            isActive={isActive}
            Icon={Icon}
            text={label}
            labelBadge={labelBadge}
          />
        )}
      </CurrentTool>
    </link.component>
  )
}

export default NavigationLink
